import React from "react";
import { isMobile } from "react-device-detect";
import ocesha_logo from "../../assets/ocesha_images/ocesha_logo.png";
import { useLocation } from "react-router-dom";
import GBALogo from '../../assets/traffic_monster/GBA_Logo.png';
import { useState, useEffect } from "react";
import { useGetUserDetailsMutation } from "redux/api/authApi";
import { getCookie } from "utils/storageUtils";
import axios from "axios";
import UserImg from "../../assets/podcast_monster/user_img.png";


const Header = () => {
  const navLinkStyle: React.CSSProperties = {
    color: "#ffffff",
    fontWeight: 400,
    cursor: "pointer",
    textDecoration: "none",
  };

  const location = useLocation();
  const isProfilePage = location.pathname.includes("/profile/");
  const [userDets, setUserDets] = useState<any>();
  const useremail = localStorage.getItem("user_email") || "";
  const [getUserDetailsMutation] = useGetUserDetailsMutation();
  const [GBAUserLogo, setGBAUserLogo] = useState<any>();
  const apiUrl = process.env.REACT_APP_RETURN_DOMAIN_NAME || "";
  const maindomain = process.env.REACT_APP_LOGOUT_DOMAIN || "";
  const isLoggedIn = localStorage.getItem("logged_in") === "true";
  const userRole = localStorage.getItem("userRole");

  const handleLogout = (e: React.MouseEvent) => {
    e.preventDefault();
    // Mirror the cleanup the inner-app dropdown does on logout so a user
    // signing out from the homepage header ends up in the same state.
    localStorage.setItem("logged_in", "false");
    localStorage.removeItem("user_email");
    localStorage.removeItem("userRole");
    localStorage.removeItem("subscription_level");
    localStorage.removeItem("activeItem");
    localStorage.clear();
    window.location.href = maindomain || "/";
  };



  const hasValidSubscription = (subscriptionLevel: any) => {
    return (
      subscriptionLevel !== undefined &&
      subscriptionLevel !== null &&
      subscriptionLevel !== ""
    );
  };

  const fetchData = async () => {
    try {
      const response = await getUserDetailsMutation({
        email: useremail || getCookie("user_email") || "",
        filter: "",
        start_date: "",
        end_date: "",
      });

      if ("data" in response) {
        setUserDets(response.data.data);
        console.log('user details =>', response.data.data);
        // console.log(response.data.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    if (isLoggedIn) {
      fetchData();
    }
  }, []);

  const getPartnerDetails = async () => {
    try {

      const response = await axios.get(
        `${apiUrl}/api/users/partners/details`,
        {
          params: {
            partner_name: (localStorage.getItem("partner_name") || userDets?.partner)/* "GPA" */,
          },
        }
      );

      if (
        response.data?.status === "success" &&
        response.data?.data
      ) {
        const data = response.data.data;
        setGBAUserLogo(data.logo_url);
      }
    } catch (err) {
      console.log("Partner details not found", err);
    }
  };

  useEffect(() => {
    const handler = (e: any) => {
      setGBAUserLogo(e.detail.logo);
    };

    window.addEventListener("partner-logo-updated", handler);

    return () => {
      window.removeEventListener("partner-logo-updated", handler);
    };
  }, []);

  useEffect(() => {
    if ((localStorage.getItem("partner_name") /* === "GPA" */ || userDets?.partner /* === 'GPA' */)) {
      getPartnerDetails();
    }
  }, []);

  return (
    <div className="container">
      <style>
        {`
          .navbar-nav .dropdown-toggle {
            display: flex;
            align-items: center;
            transition: color 0.2s ease;
          }

          .navbar-nav .dropdown-toggle:hover,
          .navbar-nav .dropdown-toggle:focus,
          .navbar-nav .dropdown-toggle.show {
            color: #4ba5eb !important;
          }

          .navbar-nav .dropdown-menu,
          .header-profile-dropdown .dropdown-menu {
            display: block;
            opacity: 0;
            visibility: hidden;
            transform: translateY(8px);
            transition: opacity 0.22s ease, transform 0.22s ease, visibility 0.22s ease;
            pointer-events: none;
            margin-top: 0px;
            min-width: 260px;
            padding: 8px;
            background-color: #0b0e24;
            border: 1px solid rgba(75, 165, 235, 0.25);
            border-radius: 8px;
            box-shadow: 4px 4px 8px #4ba5eb1f, 0 8px 24px rgba(0, 0, 0, 0.35);
          }

          .navbar-nav .dropdown-menu.show,
          .header-profile-dropdown .dropdown-menu.show {
            opacity: 1;
            visibility: visible;
            transform: translateY(0);
            pointer-events: auto;
          }

          @media (hover: hover) and (pointer: fine) {
            .navbar-nav .dropdown:hover > .dropdown-menu {
              opacity: 1;
              visibility: visible;
              transform: translateY(0);
              pointer-events: auto;
            }
          }

          .navbar-nav .dropdown-item,
          .header-profile-dropdown .dropdown-item {
            color: #e2e2e5;
            font-family: "Plus Jakarta Sans", Helvetica, sans-serif;
            font-weight: 400;
            font-size: 14px;
            border-radius: 4px;
            padding: 10px 14px;
            transition: background 0.2s ease, color 0.2s ease;
          }

          .navbar-nav .dropdown-item:hover,
          .navbar-nav .dropdown-item:focus {
            background: linear-gradient(180deg, rgb(1, 104, 181) 0%, rgb(75, 165, 235) 100%);
            color: #ffffff;
          }

          /* Profile dropdown keeps its own text color (incl. the red Logout
             item) and just gets a subtle highlight on hover, matching the
             MuiMenuItem hover style used in the inner app. */
          .header-profile-dropdown .dropdown-item:hover,
          .header-profile-dropdown .dropdown-item:focus {
            background: rgba(255, 255, 255, 0.06);
          }
        `}
      </style>
      <div className="row">
        <nav className="navbar navbar-expand-md">
          <div className="container-fluid">
            {/* LOGO */}
            <div
              className={((localStorage.getItem('partner_name') /* === 'GPA' */ || userDets?.partner /* === 'GBA' */) && GBAUserLogo && window.location.pathname !== '/') ? "navbar-brand d-flex align-items-center" : "navbar-brand"}
              style={{ width: ((localStorage.getItem('partner_name') /* === 'GPA' */ || userDets?.partner /* === 'GBA' */) && GBAUserLogo && window.location.pathname !== '/') ? "auto" : "5%", cursor: "pointer", gap: ((localStorage.getItem('partner_name') /* === 'GPA' */ || userDets?.partner /* === 'GBA' */) && GBAUserLogo && window.location.pathname !== '/') ? "12px" : '', }}
              onClick={() => window.location.href = process.env.REACT_APP_LOGOUT_DOMAIN || ''}
            >
              <img
                src={ocesha_logo}
                className="img-fluid"
                alt="logo"
                style={{ width: ((localStorage.getItem('partner_name') /* === 'GPA' */ || userDets?.partner /* === 'GBA' */) && GBAUserLogo && window.location.pathname !== '/') ? '5%' : "95%" }}
              />

              {((localStorage.getItem('partner_name') /* === 'GPA' */ || userDets?.partner /* === 'GBA' */) && GBAUserLogo && window.location.pathname !== '/') && (<img
                src={GBAUserLogo}
                className="img-fluid"
                alt="logo"
                style={{ /* width: "95%", */ marginLeft: '12px', height: '100px' }}
              />)}
            </div>

            {/* TOGGLER */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
            >
              <span>
                <i className="bi bi-list text-white" />
              </span>
            </button>

            {/* NAV ITEMS */}
            {!isProfilePage && (
              <div className="collapse navbar-collapse" id="navbarScroll">
                <ul className="navbar-nav me-auto my-2 my-lg-0 gap-4">
                  {/* HOME */}
                  <li className="nav-item">
                    <a
                      href={`${maindomain}`}
                      className="nav-link"
                      style={navLinkStyle}
                    >
                      Home
                    </a>
                  </li>

                  

                  {/* PLATFORM */}
                  <li className="nav-item dropdown">
                    <a
                      href="#"
                      className="nav-link dropdown-toggle"
                      style={navLinkStyle}
                      id="platformDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      onClick={(e) => e.preventDefault()}
                    >
                      Platform
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="platformDropdown">
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://create.ocesha.ai/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          AI Course Creator
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://instructor.ocesha.ai/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          AI Instructor
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://dont-just-complete-a-cou-h5wodzb.gamma.site/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Assessments &amp; Certifications
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://turn-your-knowledge-into-8x9sat9.gamma.site/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Publishing &amp; Monetization
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://ai-powered-marketing-aut-f24dubg.gamma.site/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          AI-Powered Marketing
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="https://ocesha-ai-for-organizati-2ssd3cm.gamma.site/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          For Organizations
                        </a>
                      </li>
                    </ul>
                  </li>

                  {/* PRICING */}
                  <li className="nav-item">
                    <a
                      href={`${apiUrl}/pricing`}
                      className="nav-link"
                      style={navLinkStyle}
                      onClick={() =>
                        sessionStorage.setItem("pricing_from_landing", "true")
                      }
                    >
                      Pricing
                    </a>
                  </li>

                  {/* ABOUT US */}
                  <li className="nav-item">
                    <a
                      href="https://about.ocesha.ai/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link"
                      style={navLinkStyle}
                    >
                      About Us
                    </a>
                  </li>

                  {/* CONTACT */}
                  <li className="nav-item">
                    <a
                      href={`${apiUrl}/contactus`}
                      className="nav-link"
                      style={navLinkStyle}
                    >
                      Contacts
                    </a>
                  </li>

                  {/* BLOGS */}
                  {/* <li className="nav-item">
                    <span
                      className="nav-link"
                      style={{ color: "#fff", cursor: "pointer" }}
                      onClick={() => window.open("/blogs", "_blank")}
                    >
                      Blogs
                    </span>
                  </li> */}

                  {/* ABOUT */}
                  {/* <li className="nav-item">
                    <a href={`${apiUrl}/aboutus`} className="nav-link" style={navLinkStyle}>
                      About Us
                    </a>
                  </li> */}

                  {/* CREATOR DIRECTORY */}
                  {/* <li className="nav-item">
                    
                      href={`${apiUrl}/codegenie/creator-directory`}
                      className="nav-link"
                      style={navLinkStyle}
                    >
                      Creator Directory
                    </a>
                  </li> */}

                  {/* COURSES DIRECTORY */}
                  {/* <li className="nav-item">
                    
                      href={`${apiUrl}/codegenie/courses-directory`}
                      className="nav-link"
                      style={navLinkStyle}
                    >
                      Courses Directory
                    </a>
                  </li> */}
                </ul>

                {/* RIGHT BUTTONS */}
                <div
                  className="d-flex gap-4 align-items-center"
                  style={{ justifyContent: isMobile ? "center" : "" }}
                >
                  {isLoggedIn ? (
                    /* PROFILE (signed in) */
                    <div className="dropdown header-profile-dropdown">
                      <a
                        href="#"
                        id="headerProfileDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onClick={(e) => e.preventDefault()}
                        style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                      >
                        <img
                          src={userDets?.user_image || UserImg}
                          alt="profile"
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            objectFit: "cover",
                            objectPosition: "top center",
                            border: "2px solid rgba(255,255,255,0.15)",
                          }}
                        />
                      </a>
                      <ul
                        className="dropdown-menu dropdown-menu-end"
                        aria-labelledby="headerProfileDropdown"
                      >
                        <li>
                          <div
                            style={{
                              padding: "10px 14px",
                              borderBottom: "1px solid rgba(255,255,255,0.08)",
                              marginBottom: "4px",
                            }}
                          >
                            <div style={{ color: "#fff", fontSize: 14, fontWeight: 600 }}>
                              {userDets?.first_name || "User"} {userDets?.last_name || ""}
                            </div>
                            <div style={{ color: "rgba(255,255,255,0.5)", fontSize: 12, marginTop: 2 }}>
                              {userDets?.email || useremail}
                            </div>
                          </div>
                        </li>
                        {userRole !== "admin" && userRole !== "student" && (
                          <li>
                            {/* "Profile" in the inner app isn't a separate route — Ocesha_new_design
                                reads ?activeItem=/localStorage "activeItem" and renders
                                InstructorProfilePage inline when it's "profile". The old
                                /profile/:mentorId route takes a mentorId, not the user's email,
                                so linking there directly was wrong. */}
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                localStorage.setItem("activeItem", "profile");
                                window.location.href = `${apiUrl}/codegenie/generated-blogs`;
                              }}
                              style={{ display: "flex", alignItems: "center", gap: 10 }}
                            >
                              <i className="bi bi-person" style={{ fontSize: 15 }} />
                              Profile
                            </a>
                          </li>
                        )}
                        <li>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              const userRole = localStorage.getItem("userRole");
                              const userEmail = localStorage.getItem("user_email") || "";
                              const subscriptionLevel = localStorage.getItem("subscription_level") || "";

                              if (userRole === "admin") {
                                window.location.href = `${apiUrl}/admin/dashboard`;
                                return;
                              } else if (userRole === "student") {
                                localStorage.setItem("activeItem", "course");
                                sessionStorage.setItem(
                                  "generatedBlogsState",
                                  JSON.stringify({ userEmail })
                                );
                              } else if (!hasValidSubscription(subscriptionLevel) && userRole === "user") {
                                window.location.href = `${apiUrl}/pricing`;
                                return;
                              } else {
                                // Default to "authority" for the "user" role
                                // (and as a fallback for any other role).
                                localStorage.setItem("activeItem", "authority");
                              }
                              window.location.href = `${apiUrl}/codegenie/generated-blogs`;
                            }}
                            style={{ display: "flex", alignItems: "center", gap: 10 }}
                          >
                            <i className="bi bi-speedometer2" style={{ fontSize: 15 }} />
                            Dashboard
                          </a>
                        </li>
                        <li>
                          <hr
                            className="dropdown-divider"
                            style={{ borderColor: "rgba(255,255,255,0.08)", margin: "4px 0" }}
                          />
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={handleLogout}
                            style={{ display: "flex", alignItems: "center", gap: 10, color: "#F87171" }}
                          >
                            <i className="bi bi-box-arrow-right" style={{ fontSize: 15 }} />
                            Logout
                          </a>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <>
                      {/* SIGN IN */}
                      {/* <button
                  className="btn btn-outline-primary px-3"
                  onClick={() => {
                    if (localStorage.getItem("logged_in") === "true") {
                      navigate("/codegenie/generated-blogs", {
                        state: {
                          userEmail:
                            localStorage.getItem("user_email") || "",
                        },
                      });
                    } else {
                      navigate("/signin");
                    }
                  }}
                >
                  Sign In
                </button> */}
                      <button
                        className="btn btn-outline-primary px-3"
                        onClick={() => {
                          const isLoggedIn =
                            localStorage.getItem("logged_in") === "true";
                          const userRole = localStorage.getItem("userRole");
                          const userEmail = localStorage.getItem("user_email") || "";
                          const subscriptionLevel = localStorage.getItem("subscription_level") || "";

                          if (!isLoggedIn) {
                            window.location.href = `${apiUrl}/signin`;
                            return;
                          }

                          // Redirect to pricing if no subscription
                          if (!hasValidSubscription(subscriptionLevel) && userRole === "user") {
                            window.location.href = `${apiUrl}/pricing`;
                            return;
                          }

                          if (userRole === "user") {
                            localStorage.setItem("activeItem", "authority");
                            window.location.href = `${apiUrl}/codegenie/generated-blogs`;
                          } else if (userRole === "student") {
                            localStorage.setItem("activeItem", "course");
                            sessionStorage.setItem(
                              "generatedBlogsState",
                              JSON.stringify({ userEmail })
                            );
                            window.location.href = `${apiUrl}/codegenie/generated-blogs`;
                          } else {
                            window.location.href = `${apiUrl}/signin`;
                          }
                        }}
                      >
                        Sign In
                      </button>

                      {/* SIGN UP */}
                      <button
                        className="button_leniar px-3"
                        onClick={() => {
                          sessionStorage.setItem(
                            "signupState",
                            JSON.stringify({ DirectSignup: "true" })
                          );
                          window.location.href = `${apiUrl}/signup`;
                        }}
                      >
                        Sign Up
                      </button>
                    </>
                  )}
                </div>
              </div>)}
          </div>
        </nav>

        <hr className="mt-3" style={{ color: "#9aa0a3" }} />
      </div>
    </div>
  );
};

export default Header;